import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditMaterialIssue() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productionOrders, setProductionOrders] = useState([]);
  const [materials, setMaterials] = useState([]);

  const [data, setData] = useState({
    production_id: "",
    raw_material_id: "",
    quantity: ""
  });

  useEffect(() => {
    fetchMaterialIssue();
    fetchProductionOrders();
    fetchMaterials();
  }, []);

  const fetchMaterialIssue = () => {
    axios.get(baseUrl + "material-issues/" + id + "/")
      .then(res => {
        setData({
          production_id: res.data.production?.id || "",
          raw_material_id: res.data.raw_material?.id || "",
          quantity: res.data.quantity
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Material Issue", "error"));
  };

  const fetchProductionOrders = () => {
    axios.get(baseUrl + "production-orders/")
      .then(res => setProductionOrders(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Production Orders", "error"));
  };

  const fetchMaterials = () => {
    axios.get(baseUrl + "eqp-search/")
      .then(res => setMaterials(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Materials", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.production_id || !data.raw_material_id || !data.quantity) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("production", data.production_id);
    _formData.append("raw_material", data.raw_material_id);
    _formData.append("quantity", data.quantity);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "material-issues/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "Material Issue Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setTimeout(() => {
          navigate('/material-issue');
        }, 2000);
      }
    })
    .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Material Issue</h4>

        <select
          name="production_id"
          value={data.production_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Production Order</option>
          {productionOrders.map(po => (
            <option key={po.id} value={po.id}>
              {po.order_no} - {po.product?.name}
            </option>
          ))}
        </select>

        <select
          name="raw_material_id"
          value={data.raw_material_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Raw Material</option>
          {materials.map(m => (
            <option key={m.id} value={m.id}>
              {m.product}
            </option>
          ))}
        </select>

        <input
          type="number"
          className="form-control mt-3"
          name="quantity"
          value={data.quantity}
          onChange={inputHandler}
          placeholder="Quantity"
        />

        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>
      </div>
    </div>
  );
}

export default EditMaterialIssue;
